import { Box, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import { checkMediaType } from '../../lib/helperFuncs';
import Theme from '../../Themes/main.theme';
import { IArrowComponent, IMediaSliders } from './types';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRigthIcon from '@mui/icons-material/ChevronRight';

const slideStyles = {
  width: '100%',
  height: '100%',
  borderRadius: '10px',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
} as const;


const rightArrowStyles = {
  position: 'absolute',
  top: '50%',
  transform: 'translate(0, -50%)',
  right: '32px',
  fontSize: '45px',
  color: Theme.titleColor?.main,
  zIndex: 1,
  cursor: 'pointer'
} as const;

const leftArrowStyles = {
  position: 'absolute',
  top: '50%',
  transform: 'translate(0, -50%)',
  left: '32px',
  fontSize: '45px',
  color: Theme.titleColor?.main,
  zIndex: 1,
  cursor: 'pointer'
} as const;

const sliderStyles = {
  position: 'relative',
  height: '100%',
} as const;

const mediaControllersStyles = {
  margin: '10px 15px',
  cursor: 'pointer',
};

//const NUMBER_OF_IMAGES_PER_SLIDE = 5;

const ImageSlider = ({ slides, setMediaIndicator, mediaIndicator }: IMediaSliders) => {
  let NUMBER_OF_IMAGES_PER_SLIDE = 4;
  const matchesLGbreakpoint = useMediaQuery('(max-width:1550px)');
  const matchesMDbreakpoint = useMediaQuery('(max-width:1024px)');
  const matchesSMbreakpoint = useMediaQuery('(max-width:768px)');
  const matchesXSbreakpoint = useMediaQuery('(max-width:480px)');

  if (matchesXSbreakpoint) {
    NUMBER_OF_IMAGES_PER_SLIDE = 1;
  } else if (matchesSMbreakpoint && matchesMDbreakpoint) {
    NUMBER_OF_IMAGES_PER_SLIDE = 2;
  } else if (matchesMDbreakpoint && matchesLGbreakpoint) {
    NUMBER_OF_IMAGES_PER_SLIDE = 3;
  } else {
    NUMBER_OF_IMAGES_PER_SLIDE = 4;
  }
  
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [currentIndicator, setCurrentIndicator] = useState<number>(0);
  const goToPrevious = () => {
    const isFirstSlide = currentIndex === 0;
    const _currentIndex = isFirstSlide
      ? slides.length - 1
      : currentIndex - 1;
    setCurrentIndex(_currentIndex);
    setCurrentIndicator(Math.trunc(_currentIndex / NUMBER_OF_IMAGES_PER_SLIDE));
  };

  const goToNext = () => {
    let _currentIndex;
    const isLastSlide = currentIndex === slides.length - 1;
    if (isLastSlide) {
      _currentIndex = 0;
    } else {
      _currentIndex = currentIndex + 1;  
    }
    setCurrentIndex(_currentIndex);
    setCurrentIndicator(Math.trunc(_currentIndex / NUMBER_OF_IMAGES_PER_SLIDE));
  };

  const goToSlide = (slideIndex: number, selectedMediaId?: number) => {
    setMediaIndicator?.(selectedMediaId);
    setCurrentIndex(slideIndex);
  };

  const slideStylesWidthBackground = {
    ...slideStyles,
    backgroundImage: `url(${slides[currentIndex]?.url})`,
  };
  
  const ArrowComponent = (props: IArrowComponent) => {
    const { onClick, style, children } = props;
    return (
      <Box onClick={onClick} style={style}>
        {children}
      </Box>);
  };

  const getNumberOfIndicators = (): number => {
    if (slides.length % NUMBER_OF_IMAGES_PER_SLIDE === 0) {
      return Math.trunc(slides.length / NUMBER_OF_IMAGES_PER_SLIDE);
    } else {
      return Math.trunc(slides.length / NUMBER_OF_IMAGES_PER_SLIDE) + 1;
    }
  };

  const renderActiveThumbnails = (indicatorKey: number): void => {
    setCurrentIndicator(indicatorKey);
    setCurrentIndex(indicatorKey * NUMBER_OF_IMAGES_PER_SLIDE);
  };

  const getArrRangeOfCurIndicator = () => {
    return { 
      start: currentIndicator * NUMBER_OF_IMAGES_PER_SLIDE, 
      end: (currentIndicator + 1) * NUMBER_OF_IMAGES_PER_SLIDE 
    };
  };
  
  return (
    <div style={sliderStyles}>
      {!mediaIndicator && 
      <div>
        <ArrowComponent onClick={goToPrevious} style={leftArrowStyles}>
          {/* ❰ */}
          <ChevronLeftIcon
            fontSize='large'
            sx={{
              backgroundColor: '#1622aa',
              border: 'solid 2px #1622aa',
              borderRadius: '50%',
              padding: 0.5
            }}
          />
        </ArrowComponent>
        <ArrowComponent onClick={goToNext} style={rightArrowStyles}>
          {/* ❱ */}
          <ChevronRigthIcon
            fontSize='large'
            sx={{
              backgroundColor: '#1622aa',
              border: 'solid 2px #1622aa',
              borderRadius: '50%',
              padding: 0.5
            }}
          />
        </ArrowComponent>
      </div>}
      <div style={{...slideStylesWidthBackground}}>
        {checkMediaType(slides[currentIndex]?.url) === 'video' &&
          <video controls style={{...slideStyles, objectFit: 'cover'}}>
            <source src={slides[currentIndex].url} type='video/mp4' />
          </video>
        }
      </div>
      <Box style={{ display: 'flex',
        justifyContent: 'center' }}>
        {slides.slice(getArrRangeOfCurIndicator().start, getArrRangeOfCurIndicator().end).
          map((slide: any, slideIndex: any) => (
            <>
              <Box display='flex'>
                <Box
                  sx={mediaControllersStyles}
                  key={slide?.mediaId || slide?.url}
                  onClick={() => goToSlide(slideIndex, slide?.mediaId)}
                >
                  <img key={slide?.url} style={{
                    maxWidth: '150px', 
                    minWidth: '150px', 
                    maxHeight: '80px', 
                    minHeight: '80px', 
                    borderRadius: '10px',
                    paddingBottom: '5px',
                    marginTop: '4px',
                    objectFit: 'cover',
                    transform: slideIndex === currentIndex
                      ? 'scale(1.1, 1.1)'
                      : ''
                  }}                
                  src={slide?.thumbnail}>
                  </img>
                </Box>
              </Box>
            </>
          ))}
      </Box>
      <Box display='flex' justifyContent='center'>
        {[...Array(getNumberOfIndicators())].map((_, indicatorKey) => {
          return (
            <>
              <div
                style={{
                  border: `2px solid ${Theme.ekomeColor?.main}`,
                  color: Theme.ekomeColor?.main,
                  borderRadius: '10px',
                  margin: '0px 1.2px',
                  minWidth: '8px',
                  minHeight: '8px',
                  cursor: 'pointer',
                  fontSize: '20px',
                  backgroundColor: indicatorKey === currentIndicator
                    ? Theme.ekomeColor?.main
                    : '',
                  borderColor: indicatorKey === currentIndicator
                    ? Theme.ekomeColor?.main
                    : '', 
                  transform: indicatorKey === currentIndicator
                    ? 'scale(1.18, 1.15)'
                    : ''
                }}
                onClick={() => renderActiveThumbnails(indicatorKey)}
              >
              </div>
            </>
          );
        })
        }
      </Box>
      
    </div>
  );
};

export default ImageSlider;